export const ADV_SEARCH_PATH = 'adv-search';
export const ADV_SEARCH_FEATURE_TOGGLE = 'adv-search-ISD-15977';
